import { render, staticRenderFns } from "./CantalMap.vue?vue&type=template&id=4fb22864&scoped=true&"
import script from "./CantalMap.vue?vue&type=script&lang=js&"
export * from "./CantalMap.vue?vue&type=script&lang=js&"
import style0 from "./CantalMap.vue?vue&type=style&index=0&id=4fb22864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb22864",
  null
  
)

export default component.exports